export const SOLD_DISPLAY_MESSAGES = {
  hideTitle: "Ẩn lượt bán trên App?",
  hideDescription: "Đại lý sẽ không còn thấy số lượt bán của sản phẩm này.",
  cancel: "Hủy",
  confirm: "Xác nhận",
  placeholder: "Nhập số lượng bán bổ sung mới...",
  extraUpdated: "Đã cập nhật lượt bán bổ sung",
  displayUpdated: "Đã cập nhật trạng thái hiển thị lượt bán",
  updateFailed: "Cập nhật thất bại, vui lòng thử lại",
  extraRequired: "Vui lòng nhập lượt bán bổ sung",
  extraInvalid: "Lượt bán bổ sung phải là số nguyên lớn hơn hoặc bằng 0",
  zeroPreview: "Không hiển thị (tổng = 0)",
  zeroDisplay: "App chưa hiện vì tổng = 0",
};

export const formatSoldCount = (count) => `${String(count).replace(/\B(?=(\d{3})+(?!\d))/g, ".")} sp`;

export const formatSoldCountPreview = (count) => {
  if (count === 0) return SOLD_DISPLAY_MESSAGES.zeroPreview;
  if (count < 1000) return String(count);
  if (count >= 1000000) return `${Math.round(count / 10000) / 100}tr`;

  return `${Math.round(count / 100) / 10}k`;
};

export const isValidExtraSoldCount = (input) => typeof input === "string" && input.length > 0 && !/[^0-9]/.test(input);

export const getSoldCountPreview = (actual, extra, input) =>
  actual + (isValidExtraSoldCount(input) ? Number(input) : extra);
